module.exports = __webpack_public_path__ + "assets/auth-bottom-left.3ca1cdaf.svg";